<div class="notification-list-item bg-white dark:bg-gray-950 rounded text-black dark:text-white hover:bg-gray-300 dark:hover:bg-gray-800">
  <div class="flex items-center space-x-1">
    <!-- icon next to the title -->
    @switch (notification.itemType) {
      @case (notificationItemType.Appointment) {
        <app-icon size="4" icon="appointment-icon"></app-icon>
      }
      @case (notificationItemType.AppointmentRequest) {
        <app-icon size="4" icon="add-appointment"></app-icon>
      }
    }

    <!-- title -->
    <span class="title">{{ notification.title }}</span>
  </div>
  <span class="subtitle">{{ notification.description }}</span>
</div>
